export const name = 'viewerManagerResponsiveApi' as const

export const ResponsiveDetachApiSymbol = Symbol('ResponsiveDetachApi')
